import VueCookies from 'vue-cookies'
import database from './data.js'
import api from '../api/api.js'

const compnayUtil = {
	/* 刷新公司信息 */
    refresh(cb) {
    	api.post('getCompanyInfo',{},false).then((res)=>{
			database.local.set('company',res.resultData);
			if(cb) {
				cb(res.resultData);
			}
		}).catch((err)=>{
			console.log(err);
		});
    },
	/* 获取公司信息 */
	info() {
		return database.local.get('company');
	},
    refreshWarehouseList(cb){
        api.post('warehouseList',{},false).then((res)=>{
            database.local.set('warehouseList',res.resultData);
            if(cb) {
                cb(res.resultData);
            }
        }).catch((err)=>{
            console.log(err);
        });
	},
    warehouseList(){
        return database.local.get('warehouseList');
	},
    isWarehouseManager(warehouse){
        if(!warehouse)
            return true;
        if(typeof database.local.user() =="undefined" || !database.local.user())
            return false;
        let user = database.local.user();
        if(user.isBoss)
            return true;
        if(typeof this.warehouseList() !=="undefined" && this.warehouseList().length>0){
            let warehouseList = this.warehouseList();
            for (let w=0; w<warehouseList.length; w++){
                if(warehouse === warehouseList[w].warehouseNumber && parseInt(warehouseList[w].isManage)===1 )
                    return true;
            }
        }
        return false;
    },
};
export default compnayUtil


// WEBPACK FOOTER //
// ./src/utils/company.js